import { useEffect } from "react"
import axios from "../api/axios"
import { useAuthStore } from "../stores/authStores"
import { useCheckoutStore } from "../stores/checkoutStore"

export const useInitAuth = () => {
  const setToken = useAuthStore((s) => s.setToken)
  const setUser = useAuthStore((s) => s.setUser)
  const setAuthLoading = useAuthStore((s) => s.setAuthLoading)
  const resetCheckout = useCheckoutStore((s) => s.reset)

  useEffect(() => {
    const initAuth = async () => {
      const params = new URLSearchParams(window.location.search)
      const tokenFromUrl = params.get("token")

      let activeToken = tokenFromUrl

      if (tokenFromUrl) {
        resetCheckout()
        localStorage.setItem("auth_token", tokenFromUrl)
        window.history.replaceState({}, document.title, window.location.pathname)
      } else {
        activeToken = localStorage.getItem("auth_token")
      }

      if (!activeToken) {
        setAuthLoading(false)
        return
      }

      setToken(activeToken)

      try {
        const res = await axios.get("me", {
          headers: {
            Authorization: `Bearer ${activeToken}`,
          },
        })

        setUser(res.data.data)

      } catch (err) {
        console.error("❌ gagal fetch user", err)

        setUser(null)
        setToken(null)

        localStorage.removeItem("auth_token")
      } finally {
        setAuthLoading(false)
      }
    }

    initAuth()
  }, [resetCheckout, setAuthLoading, setToken, setUser])
}